import React, { useState } from "react";
export const FacultyPerformanceContext = React.createContext<any>(null);
export const FacultyPerformanceContextProvider = (props: any) => {
  const [facultyPerformance, setFacultyPerformance] = useState<any>({});
  const value = {
    facultyPerformance,
    setFacultyPerformance,
  };
  return (
    <FacultyPerformanceContext.Provider value={value}>
      {props.children}
    </FacultyPerformanceContext.Provider>
  );
};
